import React from "react";
import {makeStyles} from "@material-ui/styles";
import Colors from "../styles/colors";
import {CardActionArea} from "@material-ui/core";
import {IActionButton} from "../interfaces/IActionButton";
import {ButtonTheme} from "../enums/ButtonTheme";

function ActionButton(p: IActionButton){
    let secondaryHeight:number =  (p.secondaryText === '') ? 0 : 32;
    const buttonStyle = makeStyles({
        root: {
            //structure
            width: "100%",
            height: 56 + secondaryHeight,
        },
        actionArea: {
            width: '100%',
            height: 56,
            textAlign: "center",
        },
        light: {
            background: 'rgba(255, 255, 255, 0.3)',
            height: '100%',
            borderRadius: 2,
            boxShadow: '0 3px 3px 0 rgba(71, 138, 202, 0.2)',
        },
        prime: {
            background: Colors.primary,
            height: '100%',
            borderRadius: 2,
            boxShadow: '0 3px 3px 0 rgba(71, 138, 202, 0.2)',
        },
        transparent: {
            background: "none",
            height: '100%',
            borderRadius: 2,
            boxShadow: '0 3px 3px 0 rgba(71, 138, 202, 0.2)',
        },
        label: {
            position: "relative",
            letterSpacing: 0.25,
            top: 16,
            //theming
            fontFamily: [
                'LotaGrotesque',
            ].join(','),
            color: Colors.white,
            fontStretch: "normal",
            fontStyle: "normal",
            fontSize: 18,
            fontWeight: 'bold',
        },
        secondary: {
            textAlign: "center",
        },
        secondaryLabel: {
            position: "relative",
            top: 32,
            letterSpacing: 0.25,
            //theming
            fontFamily: [
                'LotaGrotesque',
            ].join(','),
            color: Colors.white,
            fontStretch: "normal",
            fontStyle: "normal",
            fontSize: 16,
            fontWeight: 'bold',
        }
    });

    const button = buttonStyle();

    const PrimaryButton = () => {
        if(p.theme === ButtonTheme.LIGHT) {
            return(
                <div className={button.light}>
                    <span className={button.label}>
                        {p.primaryText}
                    </span>
                </div>
            )
        }
        else if(p.theme === ButtonTheme.PRIME) {
            return(
                <div className={button.light}>
                    <span className={button.label}>
                        {p.primaryText}
                    </span>
                </div>
            )
        }
        else if(p.theme === ButtonTheme.TRANSPARENT) {
            return(
                <div className={button.transparent}>
                    <span className={button.label}>
                        {p.primaryText}
                    </span>
                </div>
            )
        } else {
            //default is light.
            return(
                <div className={button.light}>
                    <span className={button.label}>
                        {p.primaryText}
                    </span>
                </div>
            )
        }
    }

    const Secondary = () => {
       return(
           <div className={button.secondary} onClick={p.secondaryOnClicked}>
                <span className={button.secondaryLabel}>
                    {p.secondaryText}
                </span>
           </div>
       )
    }

    return(
        <div className={button.root}>
            <CardActionArea className={button.actionArea} onClick={p.primaryOnClicked}>
               <PrimaryButton/>
            </CardActionArea>
            {(p.secondaryText) ? ( <Secondary/>) : ''}
        </div>

    );
}
export default ActionButton;